module.exports = __webpack_public_path__ + "img/identity.fb8a8d45.svg";